<div>A new user has been created successfully!</div>
